// `/app/developers/api-keys` virou `/app/developers?tab=keys` (WEB-121): a tela morou
// aqui até a WEB-56/107, agora é uma aba de "Webhooks e API". Rota mantida só como
// redirect, pra link antigo e favorito continuarem funcionando.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/developers/api-keys/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/developers', search: { tab: 'keys' } });
  },
});
